import { useInjection } from "@linkfluence/core/di";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { InsightPage } from "@radarly/models/insight-pages/model";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useShareInsightPageAccess() {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isError, isSuccess, reset } = useMutation(
    ({
      project,
      id,
      access,
      sharedWith,
    }: {
      project: number;
      id: InsightPage["id"];
      access: InsightPage["access"];
      sharedWith: InsightPage["sharedWith"];
    }) => {
      return repository.shareInsightPageAccess(project, id, access, sharedWith);
    }
  );
  const shareInsightPageAccess = (data: {
    project: number;
    id: InsightPage["id"];
    access: InsightPage["access"];
    sharedWith: InsightPage["sharedWith"];
  }) => {
    return mutateAsync(data);
  };
  return {
    shareInsightPageAccess,
    loading: isLoading,
    error: isError,
    success: isSuccess,
    reset: () => {
      reset();
      queryClient.invalidateQueries(["/insight-page/get"]);
    },
  };
}
